// extracted by mini-css-extract-plugin
export default {"rotateY180":"icon-generator_rotateY180__hsq1s"};